declare global {
  interface Window {
    QY_RUNTIME_CONFIG?: { apiBaseUrl?: string };
  }
}

function inferredProductionApiBase() {
  if (window.location.hostname.startsWith("www.")) {
    return `${window.location.protocol}//api.${window.location.hostname.slice(4)}`;
  }
  return "";
}

const buildEnv = (import.meta as ImportMeta & { env?: { VITE_QY_API_BASE_URL?: string } }).env;
const configuredBase = String(window.QY_RUNTIME_CONFIG?.apiBaseUrl || buildEnv?.VITE_QY_API_BASE_URL || "")
  .trim()
  .replace(/\/+$/, "");

export const apiBaseUrl = configuredBase || inferredProductionApiBase();

export function apiHref(path: string) {
  if (!path.startsWith("/api/")) return path;
  return apiBaseUrl ? `${apiBaseUrl}${path}` : path;
}

export function installApiFetchBridge() {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    let target: RequestInfo | URL = input;
    if (input instanceof Request) {
      const url = new URL(input.url, window.location.origin);
      if (url.origin === window.location.origin && url.pathname.startsWith("/api/") && apiBaseUrl) {
        target = new Request(`${apiBaseUrl}${url.pathname}${url.search}${url.hash}`, input);
      }
    } else {
      const value = String(input);
      if (value.startsWith("/api/")) target = apiHref(value);
      else if (value.startsWith(window.location.origin) && new URL(value).pathname.startsWith("/api/") && apiBaseUrl) {
        const url = new URL(value);
        target = `${apiBaseUrl}${url.pathname}${url.search}${url.hash}`;
      }
    }
    return nativeFetch(target, { credentials: "include", ...init });
  }) as typeof window.fetch;
}
